import { ExpandButton } from '@lt/components';
import Hotel from '@lt/components/icons-react/Hotel';
import { i18n } from '@lt/localization';
import React from 'react';
import { formatDateToDayShortWithYear } from 'src/utils/dateUtils';
import classnames from 'classnames';
import type { ReviewsCardProps } from '../../ReviewCard';
import {
  TEST_ID_ANSWERED_AT_REVIEW_CONTENT,
  TEST_ID_ANSWER_REVIEW_CONTENT,
} from './constants';

import styles from './answerToReview.module.css';

const AnswerToReview = ({
  answer,
  answeredAt,
  isMobile = false,
  className = '',
}: Pick<
  ReviewsCardProps,
  'answer' | 'answeredAt' | 'isMobile' | 'className'
>): JSX.Element => {
  const answeredAtDate = answeredAt && formatDateToDayShortWithYear(answeredAt);
  return (
    <div
      className={classnames(styles.answerToReview, className, {
        [styles.answerToReviewMobile]: isMobile,
      })}
      data-testid={TEST_ID_ANSWER_REVIEW_CONTENT}
    >
      <div className={styles.header}>
        <div className={styles.title}>
          <Hotel className={styles.hotel} />
          <div className={styles.subTitle}>
            {i18n.t('hotel.reviews.hotelReplyTitle')}
          </div>
        </div>
        {answeredAtDate && (
          <div
            className={styles.date}
            data-testid={TEST_ID_ANSWERED_AT_REVIEW_CONTENT}
          >
            {answeredAtDate}
          </div>
        )}
      </div>
      <ExpandButton content={answer ?? ''} visibleLine={3} />
    </div>
  );
};

export default AnswerToReview;
